import { ErreurApi } from '../api/client';

/** État vide, explicite : ce qu'on ne voit pas, et quoi faire. */
export function Vide({ titre, aide }: { titre: string; aide: string }) {
  return (
    <div className="empty">
      <b>{titre}</b>
      {aide}
    </div>
  );
}

/**
 * Erreur réseau ou serveur. Distingue une coupure (rien n'a été enregistré)
 * d'une erreur applicative, et propose toujours de réessayer.
 */
export function Erreur({ erreur, onReessayer }: { erreur: unknown; onReessayer?: () => void }) {
  const api = erreur instanceof ErreurApi ? erreur : null;
  const titre = api?.estReseau ? 'Serveur injoignable' : 'Le chargement a échoué';
  const message = api
    ? api.message
    : erreur instanceof Error
      ? erreur.message
      : 'Une erreur inattendue est survenue.';

  return (
    <div className="erreur-bloc" role="alert">
      <b>{titre}</b>
      <p style={{ marginBottom: onReessayer ? 12 : 0 }}>{message}</p>
      {api && api.details.length > 1 && (
        <ul style={{ margin: '0 0 12px', paddingLeft: 18 }}>
          {api.details.map((d) => <li key={d}>{d}</li>)}
        </ul>
      )}
      {onReessayer && (
        <button type="button" className="btn" onClick={onReessayer}>Réessayer</button>
      )}
    </div>
  );
}

export function Chargement({ libelle = 'Chargement…' }: { libelle?: string }) {
  return (
    <p style={{ color: 'var(--ink-3)', padding: '24px 0' }} role="status">
      <span className="spin" /> {libelle}
    </p>
  );
}
